// extracted by mini-css-extract-plugin
export default {"planItem":"PlanItem_planItem__kDpaX"};